import config from 'constants/config'
import { ChertoExperiments } from 'constants/experiments'
import { getExperimentEnabledDecision, isAllowedToTriggerExperiment } from 'lib/optimizely/optimizelyUtils'

/**
 * Mirrors useExperiment's Cherto treatment decision for Cars surfaces that
 * cannot use a React hook, including navigation and SSR route matching.
 */
export function selectCarsAirportTransferIsVariant(state: App.State): boolean {
  const experimentId = ChertoExperiments.carsAirportTransfer.id

  if (!isAllowedToTriggerExperiment(true, state.utm.content, experimentId)) {
    return false
  }

  const override = config[`CHERTO_${experimentId}`]
  const variationKey = override ?? state.cherto?.chertoExperiments?.[experimentId]?.variationKey

  return getExperimentEnabledDecision(variationKey)
}
